var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.625 11.375C23.625 5.09336 18.3357 0 11.8125 0C5.28926 0 0 5.09336 0 11.375C0 17.0523 4.31895 21.7582 9.9668 22.6124V14.6641H6.96674V11.375H9.9668V8.86895C9.9668 6.01859 11.7308 4.44285 14.4287 4.44285C15.7212 4.44285 17.0733 4.66527 17.0733 4.66527V7.46484H15.583C14.1165 7.46484 13.6577 8.34133 13.6577 9.24219V11.375H16.9335L16.4104 14.6641H13.6582V22.6134C19.3061 21.7598 23.625 17.0539 23.625 11.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.f722dc4c9582fd5ca93365d17b2ea8e0.svg";
export { ForwardRef as ReactComponent };